import { render } from "./candid-post-form.vue?vue&type=template&id=658934d0&scoped=true"
import script from "./candid-post-form.vue?vue&type=script&lang=js"
export * from "./candid-post-form.vue?vue&type=script&lang=js"

import "./candid-post-form.vue?vue&type=style&index=0&id=658934d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658934d0"]])

export default __exports__